import React from 'react';

const PerformanceBadge = ({ level, size = 'medium' }) => {
  if (!level) return null;

  const badges = {
    excellent: {
      emoji: '🌟',
      label: 'Excellent',
      gradient: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
      color: '#FFD700',
      textColor: '#000000',
      shadow: 'rgba(255, 215, 0, 0.5)'
    },
    good: {
      emoji: '👍',
      label: 'Good',
      gradient: 'linear-gradient(135deg, #196f3d 0%, #1e8449 100%)',
      color: '#27ae60',
      textColor: '#FFFFFF',
      shadow: 'rgba(39, 174, 96, 0.5)'
    },
    average: {
      emoji: '👌',
      label: 'Average',
      gradient: 'linear-gradient(135deg, #1f618d 0%, #2471a3 100%)',
      color: '#3498db',
      textColor: '#FFFFFF',
      shadow: 'rgba(52, 152, 219, 0.5)'
    },
    needs_work: {
      emoji: '💪',
      label: 'Needs Work',
      gradient: 'linear-gradient(135deg, #8f4a09 0%, #a85a0c 100%)',
      color: '#e67e22',
      textColor: '#FFFFFF',
      shadow: 'rgba(230, 126, 34, 0.5)'
    },
    keep_trying: {
      emoji: '🎯',
      label: 'Keep Trying',
      gradient: 'linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)',
      color: '#9b59b6',
      textColor: '#FFFFFF',
      shadow: 'rgba(155, 89, 182, 0.5)'
    }
  };

  const badge = badges[level];
  if (!badge) return null;

  const sizes = {
    small: {
      padding: '4px 12px',
      fontSize: '11px',
      emojiSize: '14px',
      height: '24px'
    },
    medium: {
      padding: '8px 16px',
      fontSize: '13px',
      emojiSize: '16px',
      height: '32px'
    },
    large: {
      padding: '12px 24px',
      fontSize: '16px',
      emojiSize: '24px',
      height: '48px'
    },
    diagonal: {
      // Diagonal badge that goes across card corner
      width: '180px',
      fontSize: '12px',
      emojiSize: '16px',
      padding: '8px 0'
    }
  };

  const sizeStyle = sizes[size];

  // Regular badge (non-diagonal)
  if (size !== 'diagonal') {
    return (
      <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        background: badge.gradient,
        color: badge.textColor,
        padding: sizeStyle.padding,
        borderRadius: '12px',
        fontWeight: '700',
        fontSize: sizeStyle.fontSize,
        height: sizeStyle.height,
        boxShadow: `0 3px 12px ${badge.shadow}`,
        border: `2px solid ${badge.color}`,
        textShadow: badge.textColor === '#000000' ? 'none' : '0 1px 2px rgba(0,0,0,0.2)'
      }}>
        <span style={{ fontSize: sizeStyle.emojiSize }}>{badge.emoji}</span>
        <span style={{ letterSpacing: '0.3px' }}>{badge.label}</span>
      </div>
    );
  }

  // Diagonal badge
  return (
    <div style={{
      position: 'absolute',
      top: '20px',
      right: '-45px',
      width: sizeStyle.width,
      background: badge.gradient,
      color: badge.textColor,
      padding: sizeStyle.padding,
      transform: 'rotate(45deg)',
      boxShadow: `0 4px 15px ${badge.shadow}`,
      zIndex: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '6px',
      fontSize: sizeStyle.fontSize,
      fontWeight: '800',
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
      border: `2px solid ${badge.color}`,
      textShadow: badge.textColor === '#000000' 
        ? '0 1px 3px rgba(255,255,255,0.5)' 
        : '0 2px 4px rgba(0,0,0,0.3)'
    }}>
      <span style={{ fontSize: sizeStyle.emojiSize }}>{badge.emoji}</span>
      <span>{badge.label}</span>
    </div>
  );
};

export default PerformanceBadge;